import {IApiBusinessProto, space} from "../provider_api";
import BusinessSubscriptionType = space.kenko.proto.BusinessSubscriptionType;
import {getSubscriptionType} from "../util/SubscriptionUtil";

type NavLink = {
  text: string,
  icon: string,
  link: string,
  requiresAdmin?: boolean,
}


const home = {text: 'Home', icon: require('../images/icons/home.png'), link: '/home',};

const calendar = {
  text: 'Calendar',
  icon: require('../images/icons/calendar_today.png'),
  link: 'calendar',
};

const clients = {
  text: 'Clients',
  icon: require('../images/icons/patient_list.png'),
  link: 'clients',
};

const catalog = {
  text: 'Catalog',
  icon: require('../images/icons/format_list_bulleted.png'),
  link: 'catalog',
  requiresAdmin: true,
};

const team = {
  text: 'Team',
  icon: require('../images/icons/groups.png'),
  link: 'team',
  requiresAdmin: true,
};

const businessProfile = {
  text: 'Business Profile',
  icon: require('../images/icons/contact_page.png'),
  link: 'profile',
  requiresAdmin: true,
};

const publishing = {
  text: 'Publishing',
  icon: require('../images/icons/web.png'),
  link: 'publishing',
  requiresAdmin: true,
};

const billing = {
  text: 'Billing',
  icon: require('../images/icons/credit_card_gear.png'),
  link: 'billing',
  requiresAdmin: true,
};

const settings = {
  text: 'Settings',
  icon: require('../images/icons/build.png'),
  link: 'settings',
  requiresAdmin: false,
};

export const navLinksForBusiness = (business: IApiBusinessProto | null | undefined) => {

  if (getSubscriptionType(business) == BusinessSubscriptionType.LISTING_PLUS_BOOKING) {
    return listingPlusBookingNavLinks;
  }

  return listingOnlyNavLinks;
}

/**
 * This is just the data for the nav links; they can be shown in two different
 * formats depending on screen width.
 */
export const listingOnlyNavLinks: NavLink[] = [
  home,
  businessProfile,
  publishing,
  settings,
];


/**
 * This is just the data for the nav links; they can be shown in two different
 * formats depending on screen width.
 */
export const listingPlusBookingNavLinks: NavLink[] = [
  home,
  calendar,
  clients,
  catalog,
  team,
  businessProfile,
  publishing,
  billing,
  settings,
];



